module.exports = __webpack_public_path__ + "templates-59e97cd7/template-3-2x-b7462c37c2aededcfbeeba676ff1d246.jpg";